let audioContext: AudioContext | null = null

function getAudioContext(): AudioContext | null {
  if (typeof window === 'undefined') return null
  const Ctx = window.AudioContext || (window as typeof window & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext
  if (!Ctx) return null
  audioContext = audioContext || new Ctx()
  return audioContext
}

/** Short two-tone message alert (no external asset required). */
export function playChatMessageSound(): void {
  try {
    const ctx = getAudioContext()
    if (!ctx) return
    if (ctx.state === 'suspended') {
      void ctx.resume()
    }

    const start = ctx.currentTime
    const tones = [
      { freq: 880, at: 0, duration: 0.18, volume: 0.14 },
      { freq: 1175, at: 0.12, duration: 0.22, volume: 0.12 },
    ]

    for (const tone of tones) {
      const oscillator = ctx.createOscillator()
      const gain = ctx.createGain()
      oscillator.type = 'sine'
      oscillator.frequency.setValueAtTime(tone.freq, start + tone.at)
      gain.gain.setValueAtTime(0.0001, start + tone.at)
      gain.gain.exponentialRampToValueAtTime(tone.volume, start + tone.at + 0.02)
      gain.gain.exponentialRampToValueAtTime(0.0001, start + tone.at + tone.duration)
      oscillator.connect(gain)
      gain.connect(ctx.destination)
      oscillator.start(start + tone.at)
      oscillator.stop(start + tone.at + tone.duration + 0.02)
    }
  } catch {
    // Ignore autoplay / audio errors
  }
}

export function getChatMessagePreview(content?: string, contentType?: string): string {
  const text = String(content || '').trim()
  if (text) return text.length > 80 ? `${text.slice(0, 80)}…` : text
  if (contentType === 'image') return 'ส่งรูปภาพ'
  if (contentType === 'file') return 'ส่งไฟล์แนบ'
  if (contentType === 'sticker') return 'ส่งสติกเกอร์'
  return 'มีข้อความใหม่จากแอดมิน'
}

export async function showChatBrowserNotification(title: string, body: string): Promise<void> {
  if (typeof window === 'undefined' || !('Notification' in window)) return

  if (Notification.permission === 'default') {
    try {
      await Notification.requestPermission()
    } catch {
      return
    }
  }

  if (Notification.permission !== 'granted') return

  try {
    new Notification(title, {
      body,
      tag: 'user-chat-admin-message',
      silent: true,
    })
  } catch {
    // Ignore notification errors
  }
}

export function notifyAdminChatMessage(preview: string): void {
  playChatMessageSound()
  void showChatBrowserNotification('ข้อความจากแอดมิน', preview)
}
